import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { RouterModule, Routes, Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpBaseComponent } from '../base/wizard/wizard-hp-base-component';

@Component({
  selector: 'app-simulation-aide',
  templateUrl: './simulation-aide.component.html',
  styleUrls: ['./simulation-aide.component.scss']
})
export class SimulationAideComponent extends WizardHpBaseComponent implements OnInit {
  etape_show = false;
  mat_stepper_width = 198;
  start_simuleo;
  constructor(chgDetectorRef: ChangeDetectorRef, hpService: HpService, 
    public dialogRef: MatDialogRef<SimulationAideComponent>,  router: Router,
     route: ActivatedRoute, @Inject(MAT_DIALOG_DATA) public dataDialog: any) {
      super(chgDetectorRef, hpService, router);
       this.start_simuleo = this.dataDialog.via;
       this.getHpService().setWarpable(false);
   
  }

  ngOnInit() {

    console.log(this.dataDialog.via);
    setTimeout(() => {
      this.etape_show = true;
      this.mat_stepper_width = this.mat_stepper_width + 142;
    }, 1000);

  }

  toLink(url) {
    this.getHpService().setStatut_user(true);
    this.getRouter().navigate(['simulateur-de-portes']);
    this.dialogRef.close({ event: 'close', data: "ok" });

  }

}
